import { render, staticRenderFns } from "./k-button.vue?vue&type=template&id=e2d02122&scoped=true"
import script from "./k-button.vue?vue&type=script&lang=js"
export * from "./k-button.vue?vue&type=script&lang=js"
import style0 from "./k-button.vue?vue&type=style&index=0&id=e2d02122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d02122",
  null
  
)

export default component.exports